import { toast } from "sonner";
import { CreditCard, Download, Printer } from "lucide-react";
import { Button } from "@/components/ui/button";
import { openBlob } from "@/lib/api";

export const PolicyDocButtons = ({ policy, size = "default", idSuffix = "", compact = false }) => {
  const tid = (base) => (idSuffix ? `${base}-${idSuffix}` : base);
  const path = `/policies/${policy.id}/policy.pdf`;
  const name = `policy-${policy.policy_number}.pdf`;
  const cards = `/policies/${policy.id}/id-cards.pdf`;
  const cardsName = `id-cards-${policy.policy_number}.pdf`;
  const showCards = policy.coverage_type !== "general_liability" && policy.status === "active";
  const fail = () => toast.error("Could not load the document");
  return (
    <div className="flex flex-wrap gap-2">
      <Button size={size} className="bg-blue-700 text-white hover:bg-blue-800 hover:text-white" onClick={() => openBlob(path, name, true).catch(fail)} data-testid={tid("download-policy-pdf-btn")}>
        <Download className="mr-2 h-4 w-4" /> {compact ? "Policy" : "Download policy"}
      </Button>
      <Button size={size} variant="outline" onClick={() => openBlob(path, name).catch(fail)} data-testid={tid("print-policy-btn")}>
        <Printer className="mr-2 h-4 w-4" /> {compact ? "Print" : "View / print"}
      </Button>
      {showCards && (
        <>
          <Button size={size} variant="outline" onClick={() => openBlob(cards, cardsName, true).catch(fail)} data-testid={tid("download-id-cards-btn")}>
            <CreditCard className="mr-2 h-4 w-4" /> {compact ? "ID cards" : "Download ID cards"}
          </Button>
          {!compact && (
            <Button size={size} variant="outline" onClick={() => openBlob(cards, cardsName).catch(fail)} data-testid={tid("print-id-cards-btn")}>
              <Printer className="mr-2 h-4 w-4" /> Print ID cards
            </Button>
          )}
        </>
      )}
    </div>
  );
};
